import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import {
  QualityCertifications,
  QualityCta,
  QualityHero,
  QualityIntro,
  QualityLabs,
  QualityProcess,
  QualitySpecs,
  QualityStats,
} from './components/Sections';

export default function Quality() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <QualityHero />
        <QualityIntro />
        <QualityProcess />
        <QualitySpecs />
        <QualityLabs />
        <QualityCertifications />
        <QualityStats />
        <QualityCta />
      </main>
      <SiteFooter />
    </div>
  );
}